export const faqItems = [
  {
    question: '如何鉴定和田玉的真伪？',
    answer: '鉴定和田玉真伪需要从多个维度综合判断：首先看光泽，真正的和田玉具有温润的油脂光泽；其次看结构，在强光下应呈纤维交织结构；第三上手感受，和田玉导热快且有油腻触感。最重要的是选择信誉好的商家，并要求出具权威鉴定证书。',
  },
  {
    question: '紫砂壶怎么开壶和养护？',
    answer: '新壶开壶可采用清水煮壶法：将壶放入冷水中，小火慢煮10-15分钟，自然冷却后取出冲洗干净即可。日常养护做到"一壶一茶"，每次用后及时清洗，趁壶身温热用茶巾擦拭壶身，避免使用洗洁精等化学清洁剂。长期不用时需完全干燥后存放。',
  },
  {
    question: '文玩把件适合新手吗？从什么品类入手比较好？',
    answer: '非常适合！文玩把件是门槛最低、趣味性最强的收藏品类之一。新手建议从菩提类（金刚、星月）或木质类（崖柏、紫檀）入手，这些品类价格亲民、辨别容易、盘玩反馈明显，能快速获得成就感。建议先从200-500元价位段开始，积累经验后再升级。',
  },
  {
    question: '你们的商品支持退换货吗？',
    answer: '我们提供7天无理由退换货服务（在不影响二次销售的前提下）。如收到商品有质量问题，请在签收后24小时内联系我们，我们将第一时间为您处理。定制类商品不支持退换货，请在下单前确认好需求。',
  },
  {
    question: '如何辨别紫砂壶的泥料是否纯正？',
    answer: '纯正紫砂泥料有几个特征：颜色自然不刺眼、表面有细微的颗粒感、断面呈不规则的片状结构。化工壶通常颜色过于鲜艳或均匀、表面过于光滑。最简单的方法是选择信誉良好的商家和工艺师，也可使用开水冲泡后闻气味，纯正紫砂不会散发刺鼻异味。',
  },
  {
    question: '工艺品摆件如何日常保养？',
    answer: '不同类型工艺品的保养方法有所不同。木质类要避免暴晒和潮湿，定期用干布擦拭；陶瓷类避免碰撞和骤冷骤热；玉石类日常佩戴就是最好的保养；金属类可用软布蘸少量专用保养剂擦拭。所有工艺品都应远离化学试剂和极端环境。',
  },
  {
    question: '可以定制专属的掌中之物吗？',
    answer: '可以的！我们接受木雕、紫砂、玉器等品类的定制需求。您可以提供设计思路或参考图片，我们的工艺师会与您沟通确认方案。定制周期一般为2-8周，具体视工艺复杂程度而定。欢迎联系客服咨询定制详情。',
  },
  {
    question: '发货和物流是如何安排的？',
    answer: '订单确认后，我们会在24小时内发货（定制商品除外）。国内统一使用顺丰快递，确保您的掌中之物安全送达。所有商品均采用防震包装，高价值商品另加保价服务。一般1-3个工作日即可送达全国大部分城市。',
  },
];